(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fanniverse-marketplaces"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fv-marketplaces')) {
    class FvMarketplaces extends HTMLElement {
      connectedCallback() { requestAnimationFrame(() => this.initialize()); }
      initialize() {
        if (this.initialized || !this.isConnected) return;
        this.initialized = true;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.reduced = matchMedia('(prefers-reduced-motion:reduce)');
        this.userPaused = false;
        this.inView = false;
        this.addEventListener('pointerdown', event => {
          if (event.pointerType === 'touch' && event.target.closest('[data-marketplace-window]')) { this.userPaused = true; this.sync(); }
        }, { signal });
        const resumeTouch = event => {
          if (event.pointerType !== 'touch' || !this.userPaused) return;
          this.userPaused = false;
          this.sync();
        };
        window.addEventListener('pointerup', resumeTouch, { signal });
        window.addEventListener('pointercancel', resumeTouch, { signal });
        this.observer = new IntersectionObserver(entries => { this.inView = entries[0].isIntersecting; this.sync(); }, { threshold:0 });
        this.observer.observe(this);
        this.reduced.addEventListener('change', () => this.sync(), { signal });
        document.addEventListener('visibilitychange', () => this.sync(), { signal });
        window.addEventListener('pageshow', () => this.sync(), { signal });
        this.sync();
      }
      sync() {
        const enabled = this.dataset.autoscroll === 'true' && !this.reduced.matches;
        this.classList.toggle('is-visible', enabled && this.inView && !document.hidden);
        this.classList.toggle('is-paused', this.userPaused);
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        this.initialized = false;
      }
    }
    customElements.define('fv-marketplaces', FvMarketplaces);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fanniverse-studio-feed"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fv-studio-feed')) {
    class FvStudioFeed extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-feed-viewport]');
        if (!this.viewport) return;
        this.abort = new AbortController();
        this.videos = [...this.querySelectorAll('[data-feed-video]')];
        this.ratios = new Map();
        this.pending = new WeakSet();
        this.retryAfterPending = new WeakSet();
        this.prev = this.querySelector('[data-feed-prev]');
        this.next = this.querySelector('[data-feed-next]');
        this.prev?.addEventListener('click', () => this.move(-1), { signal:this.abort.signal });
        this.next?.addEventListener('click', () => this.move(1), { signal:this.abort.signal });
        this.viewport.addEventListener('scroll', () => this.updateControls(), { passive:true, signal:this.abort.signal });
        this.resizeObserver = new ResizeObserver(() => this.updateControls());
        this.resizeObserver.observe(this.viewport);
        this.updateControls();

        if (!this.videos.length) return;
        this.videoObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            this.ratios.set(entry.target, entry.isIntersecting ? entry.intersectionRatio : 0);
            if (entry.isIntersecting && !entry.target.dataset.mediaLoaded) {
              entry.target.dataset.mediaLoaded = 'true';
              entry.target.querySelectorAll('source[data-fv-src]').forEach(source => { source.src = source.dataset.fvSrc; });
              entry.target.load();
            }
          });
          this.syncVideos();
        }, { threshold:[0,.25,.5,.75,1] });
        this.videos.forEach(video => {
          video.muted = true;
          video.defaultMuted = true;
          video.playsInline = true;
          video.loop = true;
          video.controls = false;
          const card = video.closest('.fv-studio-feed__card');
          card?.addEventListener('pointerenter', event => {
            if (event.pointerType !== 'mouse') return;
            this.preferredVideo = video;
            this.syncVideos();
          }, { signal:this.abort.signal });
          card?.addEventListener('pointerleave', () => {
            if (this.preferredVideo === video && !card.contains(document.activeElement)) {
              this.preferredVideo = null;
              this.syncVideos();
            }
          }, { signal:this.abort.signal });
          card?.addEventListener('focusin', () => {
            this.preferredVideo = video;
            this.syncVideos();
          }, { signal:this.abort.signal });
          card?.addEventListener('focusout', () => {
            this.preferredVideo = null;
            this.syncVideos();
          }, { signal:this.abort.signal });
          ['loadedmetadata','loadeddata','canplay','play'].forEach(event => video.addEventListener(event, () => this.syncVideos(), { signal:this.abort.signal }));
          this.videoObserver.observe(video);
        });
        document.addEventListener('visibilitychange', () => this.syncVideos(), { signal:this.abort.signal });
        window.addEventListener('pageshow', () => this.syncVideos(), { signal:this.abort.signal });
        document.addEventListener('play', event => {
          if (event.target instanceof HTMLVideoElement && !this.contains(event.target)) this.pauseVideos();
        }, { capture:true, signal:this.abort.signal });
        document.addEventListener('pause', event => {
          if (event.target instanceof HTMLVideoElement && !this.contains(event.target)) this.syncVideos();
        }, { capture:true, signal:this.abort.signal });
      }
      move(direction) {
        const card = this.querySelector('.fv-studio-feed__card');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.querySelector('.fv-studio-feed__track')).columnGap) || 0;
        this.viewport.scrollBy({ left:direction * (card.getBoundingClientRect().width + gap), behavior:'smooth' });
      }
      updateControls() {
        if (!this.prev || !this.next) return;
        const remaining = this.viewport.scrollWidth - this.viewport.clientWidth;
        this.prev.disabled = this.viewport.scrollLeft < 4;
        this.next.disabled = this.viewport.scrollLeft >= remaining - 4;
      }
      pauseVideos() { this.videos.forEach(video => { if (!video.paused) video.pause(); }); }
      syncVideos() {
        if (!this.videos.length) return;
        const anotherVideoPlaying = [...document.querySelectorAll('video')].some(video => !this.contains(video) && !video.paused);
        let active = null;
        let best = .25;
        if (!document.hidden && !anotherVideoPlaying) {
          this.videos.forEach(video => {
            const ratio = this.ratios.get(video) || 0;
            if (ratio > best && video.dataset.mediaLoaded) { best = ratio; active = video; }
          });
          if (this.preferredVideo?.dataset.mediaLoaded && (this.ratios.get(this.preferredVideo) || 0) > .25) active = this.preferredVideo;
        }
        this.videos.forEach(video => { if (video !== active && !video.paused) video.pause(); });
        if (active && active.paused && this.pending.has(active)) this.retryAfterPending.add(active);
        if (active && active.paused && !this.pending.has(active)) {
          this.pending.add(active);
          const attempt = active.play();
          if (attempt) attempt.catch(() => {}).finally(() => {
            this.pending.delete(active);
            if (this.retryAfterPending.delete(active) && this.isConnected) this.syncVideos();
          });
          else this.pending.delete(active);
        }
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.videoObserver?.disconnect();
        this.resizeObserver?.disconnect();
        this.pauseVideos();
      }
    }
    customElements.define('fv-studio-feed', FvStudioFeed);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-customer-stories"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fv-community-reviews')) {
    class FvCommunityReviews extends HTMLElement {
      connectedCallback() {
        requestAnimationFrame(() => this.initialize());
      }
      initialize() {
        if (this.initialized || !this.isConnected) return;
        this.sources = this.querySelector('[data-community-sources]');
        this.streams = this.querySelector('[data-community-streams]');
        this.mobileControls = this.querySelector('[data-community-mobile-controls]');
        this.mobilePosition = this.querySelector('[data-community-position]');
        if (!this.sources || !this.streams) return;
        this.cards = [...this.sources.querySelectorAll('[data-community-card]')];
        if (!this.cards.length) return;
        this.initialized = true;
        this.abort = new AbortController();
        this.signal = this.abort.signal;
        this.mobile = matchMedia('(max-width:767px)');
        this.reduced = matchMedia('(prefers-reduced-motion:reduce)');
        this.manualPaused = false;
        this.inView = false;
        this.addEventListener('click', event => {
          const stepButton = event.target.closest('[data-community-step]');
          if (stepButton) { this.mobileLastInteraction = Date.now(); this.advanceMobile(Number(stepButton.dataset.communityStep)); return; }
          const mediaButton = event.target.closest('[data-community-media-index]');
          if (mediaButton) {
            this.mobileLastInteraction = Date.now();
            const gallery = mediaButton.closest('[data-community-gallery]');
            const index = Number(mediaButton.dataset.communityMediaIndex);
            gallery.querySelectorAll('[data-community-media-item]').forEach((item, order) => { item.hidden = order !== index; });
            gallery.querySelectorAll('[data-community-media-index]').forEach(button => button.setAttribute('aria-pressed', String(button === mediaButton)));
            this.syncVideos();
            return;
          }
          const button = event.target.closest('[data-community-expand]');
          if (!button) return;
          this.mobileLastInteraction = Date.now();
          const quote = button.closest('[data-community-quote]');
          const expanded = quote.classList.toggle('is-expanded');
          button.setAttribute('aria-expanded', String(expanded));
          button.textContent = expanded ? 'Show less' : 'Read more';
          this.classList.toggle('has-expanded', !!this.querySelector('.fv-community__quote.is-expanded'));
          if (this.mobile.matches) requestAnimationFrame(() => this.updateMobileHeight());
          if (!expanded && !this.classList.contains('has-expanded')) this.scheduleBuild();
        }, { signal:this.signal });
        this.addEventListener('pointerdown', event => {
          if (event.pointerType === 'touch' && this.mobile.matches && event.target.closest('.fv-community__column')) {
            this.mobileLastInteraction = Date.now();
            this.manualPaused = true;
            this.syncPlayback();
          }
        }, { signal:this.signal });
        const resumeTouch = event => {
          if (event.pointerType !== 'touch' || !this.manualPaused) return;
          this.manualPaused = false;
          this.syncPlayback();
        };
        window.addEventListener('pointerup', resumeTouch, { signal:this.signal });
        window.addEventListener('pointercancel', resumeTouch, { signal:this.signal });
        this.addEventListener('focusin', event => {
          if (event.target.closest('.fv-community__streams') && event.target.matches(':focus-visible')) this.classList.add('has-keyboard-focus');
        }, { signal:this.signal });
        this.addEventListener('focusout', () => {
          requestAnimationFrame(() => {
            if (!this.streams.contains(document.activeElement)) this.classList.remove('has-keyboard-focus');
          });
        }, { signal:this.signal });
        this.sectionObserver = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          this.syncPlayback();
        }, { threshold:0 });
        this.sectionObserver.observe(this);
        this.mobile.addEventListener('change', () => this.scheduleBuild(), { signal:this.signal });
        this.reduced.addEventListener('change', () => { if (this.reduced.matches) this.finishCounter(); else if (this.counterInView && !document.hidden) this.startCounter(); this.scheduleBuild(); }, { signal:this.signal });
        document.addEventListener('visibilitychange', () => { if (document.hidden) this.finishCounter(); else if (this.counterInView) this.startCounter(); this.syncPlayback(); }, { signal:this.signal });
        window.addEventListener('pageshow', () => this.syncPlayback(), { signal:this.signal });
        this.lastWidth = this.clientWidth;
        this.resizeObserver = new ResizeObserver(() => {
          const width = this.clientWidth;
          if (Math.abs(width - this.lastWidth) > 1) { this.lastWidth = width; this.scheduleBuild(); }
        });
        this.resizeObserver.observe(this);
        this.setupCounter();
        this.build();
        if (document.fonts) document.fonts.ready.then(() => { if (this.isConnected) this.scheduleBuild(); });
      }
      setupCounter() {
        this.counter = this.querySelector('[data-community-counter]');
        this.counterDigits = this.counter?.querySelector('[data-community-counter-digits]');
        this.counterText = this.counter?.dataset.communityCounter;
        this.counterRun = (this.counterRun || 0) + 1;
        this.counterInView = false;
        this.counterPlayed = false;
        if (!this.counterDigits || !/^\d[\d,]*$/.test(this.counterText) || this.reduced.matches) return;
        this.counterObserver = new IntersectionObserver(entries => {
          const entry = entries[0];
          this.counterInView = entry.isIntersecting && entry.intersectionRatio >= .6;
          if (this.counterInView && !document.hidden) this.startCounter();
          else if (this.counterPlayed) this.finishCounter();
        }, { threshold:[0,.6] });
        this.counterObserver.observe(this.counter);
      }
      startCounter() {
        if (this.counterPlayed || !this.isConnected || this.reduced.matches) return;
        this.counterPlayed = true;
        const run = this.counterRun;
        const target = Number(this.counterText.replaceAll(',', ''));
        const started = performance.now();
        let lastPaint = 0;
        const tick = now => {
          if (this.counterRun !== run || !this.isConnected) return;
          const progress = Math.min((now - started) / 1100, 1);
          if (now - lastPaint >= 32 || progress === 1) {
            const eased = 1 - Math.pow(1 - progress, 3);
            this.counterDigits.textContent = Math.round(target * eased).toLocaleString('en-US');
            lastPaint = now;
          }
          if (progress < 1) this.counterFrame = requestAnimationFrame(tick);
          else this.finishCounter();
        };
        this.counterFrame = requestAnimationFrame(tick);
      }
      finishCounter() {
        if (!this.counterPlayed) return;
        cancelAnimationFrame(this.counterFrame);
        if (this.counterDigits) this.counterDigits.textContent = this.counterText;
        this.counterObserver?.disconnect();
      }
      scheduleBuild() {
        cancelAnimationFrame(this.buildFrame);
        this.buildFrame = requestAnimationFrame(() => { if (this.isConnected && !this.classList.contains('has-expanded')) this.build(); });
      }
      cloneCard(card) {
        const clone = card.cloneNode(true);
        clone.setAttribute('aria-hidden','true');
        clone.querySelectorAll('a,button,[tabindex]').forEach(element => element.setAttribute('tabindex','-1'));
        clone.removeAttribute('data-shopify-editor-block');
        clone.querySelectorAll('[data-shopify-editor-block]').forEach(element => element.removeAttribute('data-shopify-editor-block'));
        clone.querySelectorAll('video').forEach(video => {
          video.removeAttribute('src');
          video.querySelectorAll('source').forEach(source => source.removeAttribute('src'));
        });
        return clone;
      }
      build() {
        clearInterval(this.mobileTimer);
        this.mobileScrollAbort?.abort();
        clearTimeout(this.mobileScrollTimeout);
        this.mobileColumn = null;
        this.mobileControls.hidden = true;
        this.videoObserver?.disconnect();
        this.videoAbort?.abort();
        this.querySelectorAll('video').forEach(video => video.pause());
        this.classList.remove('is-ready');
        this.streams.replaceChildren();
        this.sources.hidden = true;
        this.streams.hidden = false;
        const columns = this.mobile.matches ? 1 : 3;
        const fanCards = this.cards.filter(card => card.dataset.communityCategory !== 'heater');
        const heaterCards = this.cards.filter(card => card.dataset.communityCategory === 'heater');
        const speed = (Number(this.dataset.speed) || 22) * (this.reduced.matches ? .5 : 1);
        for (let index=0; index<columns; index++) {
          const column = document.createElement('div');
          column.className = 'fv-community__column';
          const track = document.createElement('div');
          track.className = 'fv-community__track';
          const group = document.createElement('div');
          group.className = 'fv-community__group';
          const pool = this.mobile.matches ? this.cards : (index === 2 && heaterCards.length ? heaterCards : (fanCards.length ? fanCards : this.cards));
          const offset = this.mobile.matches ? 0 : index * Math.ceil(pool.length / (heaterCards.length ? 2 : columns));
          const selected = pool.map((card, order) => pool[(order + offset) % pool.length]);
          const useOriginal = index === 0 || (!this.mobile.matches && index === 2 && heaterCards.length && fanCards.length);
          selected.forEach(card => group.append(useOriginal ? card : this.cloneCard(card)));
          track.append(group);
          column.append(track);
          this.streams.append(column);
          if (this.mobile.matches) {
            column.style.setProperty('--mobile-card-width', column.clientWidth + 'px');
            this.mobileColumn = column;
            this.mobileGroup = group;
            this.mobileIndex = 0;
            this.mobileLastInteraction = 0;
            this.mobileControls.hidden = selected.length < 2;
            this.updateMobilePosition();
            this.updateMobileHeight();
            this.mobileScrollAbort = new AbortController();
            column.addEventListener('scroll', () => {
              clearTimeout(this.mobileScrollTimeout);
              this.mobileScrollTimeout = setTimeout(() => {
                this.mobileIndex = Math.max(0, Math.min(selected.length - 1, Math.round(column.scrollLeft / column.clientWidth)));
                this.updateMobilePosition();
                this.updateMobileHeight();
              }, 120);
            }, { passive:true, signal:this.mobileScrollAbort.signal });
            this.mobileTimer = setInterval(() => {
              if (this.inView && !document.hidden && !this.manualPaused && !this.reduced.matches &&
                  !this.classList.contains('has-expanded') && !this.classList.contains('has-keyboard-focus') &&
                  Date.now() - this.mobileLastInteraction > 10000) this.advanceMobile(1);
            }, 7000);
            continue;
          }
          const measure = () => this.mobile.matches ? group.getBoundingClientRect().width : group.getBoundingClientRect().height;
          const minimum = this.mobile.matches ? column.clientWidth + selected[0].getBoundingClientRect().width : column.clientHeight + selected[0].getBoundingClientRect().height;
          let repetitions = 0;
          while (measure() < minimum && repetitions < 8) {
            selected.forEach(card => group.append(this.cloneCard(card)));
            repetitions++;
          }
          const copy = document.createElement('div');
          copy.className = 'fv-community__group fv-community__copy';
          copy.setAttribute('aria-hidden','true');
          [...group.children].forEach(card => copy.append(this.cloneCard(card)));
          track.append(copy);
          const distance = measure();
          track.style.setProperty('--loop-distance', distance + 'px');
          track.style.setProperty('--loop-duration', Math.max(distance / speed, 15) + 's');
        }
        this.querySelectorAll('[data-community-quote]').forEach(quote => {
          const text = quote.querySelector('[data-community-text]');
          const button = quote.querySelector('[data-community-expand]');
          button.hidden = text.scrollHeight <= text.clientHeight + 2;
        });
        this.classList.add('is-ready');
        this.setupVideos();
        this.syncPlayback();
      }
      updateMobilePosition() {
        if (this.mobilePosition && this.mobileGroup) this.mobilePosition.textContent = `${this.mobileIndex + 1} / ${this.mobileGroup.children.length}`;
      }
      updateMobileHeight() {
        const card = this.mobileGroup?.children[this.mobileIndex];
        if (this.mobileColumn && card) this.mobileColumn.style.height = Math.ceil(card.getBoundingClientRect().height) + 'px';
      }
      advanceMobile(step) {
        if (!this.mobileColumn || !this.mobileGroup) return;
        const cards = [...this.mobileGroup.children];
        if (!cards.length) return;
        this.mobileIndex = (this.mobileIndex + step + cards.length) % cards.length;
        this.updateMobileHeight();
        this.mobileColumn.scrollTo({ left:cards[this.mobileIndex].offsetLeft - cards[0].offsetLeft, behavior:this.mobileIndex === 0 ? 'instant' : 'smooth' });
        this.updateMobilePosition();
      }
      setupVideos() {
        this.videos = [...this.streams.querySelectorAll('[data-fv-community-video]')];
        this.videoRatios = new Map();
        this.playPending = new WeakSet();
        this.videoAbort = new AbortController();
        this.videoObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            this.videoRatios.set(entry.target, entry.isIntersecting ? entry.intersectionRatio : 0);
            if (entry.isIntersecting && !entry.target.dataset.mediaLoaded) {
              entry.target.dataset.mediaLoaded = 'true';
              delete entry.target.dataset.mediaFailed;
              entry.target.querySelectorAll('source[data-fv-src]').forEach(source => source.src = source.getAttribute('data-fv-src'));
              entry.target.load();
            }
          });
          this.syncVideos();
        }, { threshold:[0,.2,.4,.6,.8,1] });
        this.videos.forEach(video => {
          video.muted = true;
          video.defaultMuted = true;
          video.playsInline = true;
          video.loop = true;
          video.controls = false;
          ['loadedmetadata','loadeddata','canplay','play'].forEach(event => video.addEventListener(event, () => this.syncVideos(), { signal:this.videoAbort.signal }));
          video.addEventListener('error', () => {
            if (video.dataset.mediaLoaded && video.currentSrc) video.dataset.mediaFailed = 'true';
          }, { signal:this.videoAbort.signal });
          this.videoObserver.observe(video);
        });
      }
      syncVideos() {
        if (!this.videos) return;
        let active = null;
        let best = .2;
        if (this.inView && !document.hidden) {
          this.videos.forEach(video => {
            const ratio = this.videoRatios.get(video) || 0;
            if (ratio > best && !video.closest('[hidden]') && video.dataset.mediaLoaded && !video.dataset.mediaFailed) { best = ratio; active = video; }
          });
        }
        this.videos.forEach(video => { if (video !== active && !video.paused) video.pause(); });
        if (active && active.paused && !this.playPending.has(active)) {
          active.muted = true;
          this.playPending.add(active);
          const attempt = active.play();
          if (attempt) attempt.catch(() => {}).finally(() => this.playPending.delete(active));
          else this.playPending.delete(active);
        }
      }
      syncPlayback() {
        this.classList.toggle('is-visible', this.inView && !document.hidden);
        this.classList.toggle('is-paused', this.manualPaused);
        this.syncVideos();
      }
      disconnectedCallback() {
        this.finishCounter();
        clearInterval(this.mobileTimer);
        this.mobileScrollAbort?.abort();
        clearTimeout(this.mobileScrollTimeout);
        this.counterObserver?.disconnect();
        this.abort?.abort();
        this.videoAbort?.abort();
        this.sectionObserver?.disconnect();
        this.videoObserver?.disconnect();
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.buildFrame);
        this.videos?.forEach(video => video.pause());
        if (this.sources && this.cards) this.cards.forEach(card => this.sources.append(card));
        if (this.streams) { this.streams.replaceChildren(); this.streams.hidden = true; }
        if (this.sources) this.sources.hidden = false;
        this.initialized = false;
      }
    }
    customElements.define('fv-community-reviews', FvCommunityReviews);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["table-fan-product"]) return;
  try {
    
  document.addEventListener('change', (event) => {
    const option = event.target;
    if (!option.matches('[data-variant-option]') || !option.checked) return;
    const field = option.form?.querySelector('[data-table-restock-variant]');
    if (field) field.value = option.value;
  });

  } catch(e) { console.error(e); }
})();
})();
